var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02Sleep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{transform-origin:120px 200px;animation:breathe 4s ease-in-out infinite}\n@keyframes breathe{0%,100%{transform:scale(1,1)}50%{transform:scale(1.03,.96)}}\n.z{opacity:0;animation:float 3s ease-out infinite}\n.z2{animation-delay:1s}.z3{animation-delay:2s}\n@keyframes float{0%{opacity:0;transform:translate(0,0) scale(.6)}20%{opacity:1}100%{opacity:0;transform:translate(22px,-55px) scale(1.2)}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 55,
    width: 160,
    height: 150,
    rx: 52,
    fill: "#6FE3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 118 Q90 130 104 118",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 118 Q150 130 164 118",
    fill: "none",
    stroke: "#0E2A2E",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 158,
    rx: 11,
    ry: 14,
    fill: "#0E2A2E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6FE3D0",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M182 58 h20 l-20 22 h20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z z2",
    d: "M182 58 h20 l-20 22 h20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z z3",
    d: "M182 58 h20 l-20 22 h20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Sleep);
export default __webpack_public_path__ + "static/media/02-sleep.f6aceaca8e2916ce8001d455edba61fd.svg";
export { ForwardRef as ReactComponent };